import { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import Email from './email/Email';
import AddNewEmail from './addNewEmail/AddNewEmail';

import classes from './AlternateEmails.module.css';

const AlternateEmails = props => {
  const [emailsData, setEmailsData] = useState(props.emails);
  const [openDialogEmail, setOpenDialogEmail] = useState(false);

  const addNewEmailHandler = (alias, type, action) => {
    const data = {
      data: {
        alias,
        email: type
      },
      action
    };
    props.updateAlias(data);
    setEmailsData([
      ...emailsData,
      {
        alias,
        email: type
      }
    ]);
    props.changesHandler(true);
  };

  const dialogNewEmailHandler = () => {
    setOpenDialogEmail(!openDialogEmail);
  };

  const deleteEmailHanlder = (alias, type, action) => {
    const data = {
      data: {
        alias,
        email: type
      },
      action
    };
    props.updateAlias(data);
    props.changesHandler(true);
  };

  return (
    <>
      <p className={classes.text}>Emails alternos</p>
      <Button
        onClick={dialogNewEmailHandler}
        className={classes.addNewEmailBtn}
      >
        Agregar correo
      </Button>
      <div className={classes.emailsContainer}>
        {emailsData.map(
          email =>
            email.email === 1 && (
              <Email
                key={email.alias}
                email={email}
                deleteEmail={deleteEmailHanlder}
              />
            )
        )}
      </div>
      {openDialogEmail && (
        <AddNewEmail
          open={openDialogEmail}
          close={dialogNewEmailHandler}
          addNewEmail={addNewEmailHandler}
        />
      )}
    </>
  );
};

AlternateEmails.propTypes = {
  // eslint-disable-next-line react/require-default-props
  emails: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  changesHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  updateAlias: PropTypes.func
};

export default AlternateEmails;
